import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { getFormattedPrice } from '../../utils/offer';
import { OFFER_ANCHOR } from '../../data/offer';
export function StickyMobileCta() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  const reduce = useReducedMotion();
  const price = getFormattedPrice();
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const offerEl = document.getElementById('offer-details');
    const observer = offerEl ? new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.1
    }) : null;
    if (offerEl && observer) observer.observe(offerEl);
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer?.disconnect();
    };
  }, []);
  return <AnimatePresence data-id="element-248" data-mp="19acrem4f3cks">
      {pastHero && !offerVisible && <motion.div initial={reduce ? {
      opacity: 0
    } : {
      y: '100%'
    }} animate={reduce ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduce ? {
      opacity: 0
    } : {
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-moss bg-forest/95 pb-[env(safe-area-inset-bottom)] backdrop-blur" data-id="element-249" data-mp="1dczph4roltqf">
          <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3 sm:px-5" data-id="element-250" data-mp="um8gw5fiq7d3">
            <div className="min-w-0 flex-1" data-id="element-251" data-mp="zll2kmunl8e3">
              <p className="truncate font-display text-lg font-extrabold uppercase leading-none text-white md:text-xl" data-id="element-252" data-mp="zkt679t8f6mr">
                HYROX Mega Pack™
              </p>
              {price && <p className="mt-1 text-sm font-semibold text-gold" data-id="element-253" data-mp="6xp9rt87g0ml">{price} · 26 weeks + 5 bonuses</p>}
            </div>
            <a href={OFFER_ANCHOR} className="inline-flex min-h-[3rem] shrink-0 items-center rounded-lg bg-cta px-5 font-sans text-base font-bold uppercase text-white shadow-[0_4px_0_#15803D] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-1 active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-gold" data-id="element-254" data-mp="bupfu45213dp">
              Get it now
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}